module.exports = __webpack_public_path__ + "media/images/icons/social-instagram-1e91878205ea298d48856e209d45662c.svg";